import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-table",
  standalone: true,
  templateUrl: "./table.component.html",
  styleUrl: "./table.component.scss"
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class TableComponent {}
